module.exports = __webpack_public_path__ + "static/media/giftsReceived_50_75.d17ffc1c.png";